/* Diamond Dust theme JS — countdown, cart drawer, product form */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minEl = el.querySelector('[data-minutes]');
    var secEl = el.querySelector('[data-seconds]');

    function tick() {
      var now = Date.now();
      var diff = target - now;
      if (isNaN(target) || diff <= 0) {
        el.classList.add('countdown--ended');
        [daysEl, hoursEl, minEl, secEl].forEach(function (n) { if (n) n.textContent = '00'; });
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minEl) minEl.textContent = String(m).padStart(2, '0');
      if (secEl) secEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ---------- Mobile nav ---------- */
  document.querySelectorAll('[data-mobile-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('.site-nav');
      if (!nav) return;
      var isOpen = nav.style.display === 'flex';
      nav.style.display = isOpen ? '' : 'flex';
      nav.style.flexDirection = 'column';
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---------- Delivery method toggle (ship vs local pickup) ---------- */
  function setDeliveryUI(value) {
    document.querySelectorAll('[data-delivery-method]').forEach(function (input) {
      input.checked = (input.value === value);
    });
    document.querySelectorAll('[data-pickup-note]').forEach(function (note) {
      note.hidden = (value !== 'pickup');
    });
    document.querySelectorAll('[data-checkout-btn]').forEach(function (btn) {
      btn.textContent = value === 'pickup' ? 'Checkout & Pay' : 'Checkout';
    });
  }

  document.querySelectorAll('[data-delivery-method]').forEach(function (input) {
    input.addEventListener('change', function () {
      var value = input.value;
      setDeliveryUI(value);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery Method': value } })
      }).catch(function () { /* non-fatal — attribute just won't persist */ });
    });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('[data-cart-count]');
          if (countEl) countEl.textContent = cart.item_count;
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Added ✓'; setTimeout(function () { submitBtn.textContent = submitBtn.dataset.originalText; }, 1500); }
          openDrawer();
          window.location.reload(); /* simplest reliable way to refresh drawer markup server-side; swap for full ajax render if desired */
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
          alert('That item just sold out — sorry! Try another size or check back next drop.');
        });
    });
  });
});
